/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { getRequest, patchRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { FaFilePdf } from 'react-icons/fa';

const UpdateNews = () => {
    const { id } = useParams();
    const [formData, setFormData] = useState({
        title: '',
        type: 'news',
        publishedAt: '',
        content: '',
        is_active: true,
        file: null
    });
    const [existingFile, setExistingFile] = useState('');
    const [loading, setLoading] = useState(false);
    const [fetching, setFetching] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchNewsDetails = async () => {
            try {
                const res = await getRequest(`news/${id}?all=true`);
                const data = res?.data;
                if (data) {
                    setFormData({
                        title: data.title || '',
                        type: data.type || 'news',
                        publishedAt: data.publishedAt ? new Date(data.publishedAt).toISOString().split('T')[0] : '',
                        content: data.content || '',
                        is_active: data.is_active,
                        file: null
                    });
                    setExistingFile(data.file);
                }
            } catch (err) {
                console.error(err);
                toast.error("Failed to load announcement details.");
            } finally {
                setFetching(false);
            }
        };

        fetchNewsDetails();
    }, [id]);

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'file' ? e.target.files[0] : value
        }));
    };

    const handleSelectChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value === 'true'
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const data = new FormData();
        data.append('title', formData.title);
        data.append('type', formData.type);
        data.append('publishedAt', formData.publishedAt);
        data.append('content', formData.content);
        data.append('is_active', formData.is_active);
        
        if (formData.file) {
            data.append('file', formData.file);
        }

        try {
            await patchRequest(`news/${id}`, data);
            toast.success('Announcement updated successfully!');
            navigate('/news');
        } catch (error) {
            console.error('Failed to update news:', error);
            toast.error(error?.message || 'Error occurred while updating news.');
        } finally {
            setLoading(false);
        }
    };

    if (fetching) {
        return (
            <div className="text-center my-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className='container-fluid mt-5 mb-5'>
                <div className='mainheadig mx-4 mb-4'>
                    <h4 className='text-white font-weight-bold'>Update Announcement</h4>
                </div>
                <form onSubmit={handleSubmit} className="mx-4 p-4 card shadow">
                    <div className='row'>
                        <div className='col-sm-8 form-group'>
                            <label className='admin-label font-weight-bold'>Title *</label>
                            <input
                                type='text'
                                name='title'
                                className='form-control'
                                value={formData.title}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className='col-sm-4 form-group'>
                            <label className='admin-label font-weight-bold'>Type *</label>
                            <select
                                name='type'
                                className='form-control'
                                value={formData.type}
                                onChange={handleChange}
                                required
                            >
                                <option value="news">News</option>
                                <option value="press release">Press Release</option>
                                <option value="circular">Circular</option>
                                <option value="notification">Notification</option>
                                <option value="recruitment">Recruitment</option>
                            </select>
                        </div>

                        <div className='col-sm-4 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Published Date</label>
                            <input
                                type='date'
                                name='publishedAt'
                                className='form-control'
                                value={formData.publishedAt}
                                onChange={handleChange}
                            />
                        </div>

                        <div className='col-sm-12 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Announcement Content</label>
                            <textarea
                                name='content'
                                className='form-control'
                                rows="6"
                                value={formData.content}
                                onChange={handleChange}
                            ></textarea>
                        </div>

                        <div className='col-sm-6 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Status</label>
                            <select
                                name="is_active"
                                className="form-control"
                                value={formData.is_active ? "true" : "false"}
                                onChange={handleSelectChange}
                            >
                                <option value="true">Active</option>
                                <option value="false">Inactive</option>
                            </select>
                        </div>

                        <div className='col-sm-12 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Replace Circular Document</label>
                            <input
                                type='file'
                                name='file'
                                className='form-control filebg'
                                onChange={handleChange}
                                accept=".pdf,image/*"
                            />
                            {existingFile && !formData.file && (
                                <div className="mt-2">
                                    <small className="text-muted d-block">Current Document:</small>
                                    <a
                                        href={`${process.env.REACT_APP_BACKEND}uploads/${existingFile}`}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="btn btn-sm btn-outline-danger mt-1"
                                    >
                                        <FaFilePdf size={16} className="mr-1" /> View Existing Circular
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>
                    
                    <div className='mt-4 text-right'>
                        <button
                            type="button"
                            className="btn btn-secondary mr-2"
                            onClick={() => navigate('/news')}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className='btn addbtn pl-4 pr-4'
                            disabled={loading}
                        >
                            {loading ? 'Updating...' : 'Update Announcement'}
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default UpdateNews;
